/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const getAdvisoriesWithinBounding = (
  st: SpanTag,
  geojson: any,
): Promise<APIResponse> => {
  const encodedGeojson = encodeURIComponent(JSON.stringify(geojson));
  const url = `${config.API_URL}/v1/airmap/airspace?geometry=${encodedGeojson}`;
  return fetchAPI(stleaf(st, 'eojaz8'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getAdvisoryById = (
  st: SpanTag,
  id: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/airmap/airspace/${id}`;
  return fetchAPI(stleaf(st, 'ek7bem'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getAuthToken = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/airmap/token`;
  return fetchAPI(stleaf(st, 'zei7oj'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
